import { combineReducers } from 'redux'
import FlightDetailsReducer from './flightDetails'
import StationReducer from './stationNames'

const rootReducer = combineReducers({
    flightDetail:FlightDetailsReducer,
    StationDetail:StationReducer
})

export default rootReducer;

